<template>
  <div>
    <!-- <h1>HomePage!</h1> -->
    <router-view/>
  </div>
</template>

<script>
import AuthenticationService from '@/common/services/authentication.service';
import JwtService from '@/common/services/jwt.service';

export default {
  name: 'Home',
  data() {
    return {
      jwt: JwtService.parseJwt(),
    };
  },
  created() {

  },
  components: {
    JwtService,
  },
  methods: {
    logout() {
      AuthService.logout();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
